import { enUS } from 'date-fns/locale';

const en = {
  Allitemsshown: 'All items shown',
  Back: 'Back',
  BrowserRequirements: 'Browser requirements',
  Cancel: 'Cancel',
  Clear: 'Clear',
  Clickhere: 'Click here',
  Description: 'Description',
  Folder: 'Folder',
  Hide: 'Hide',
  ID: 'ID',
  Loading: 'Loading...',
  maintenanceModeSubtitle: '$(ProductName) is currently undergoing scheduled maintenance, please check back around ',
  maintenanceModeTitle: '$(ProductName) is down for scheduled maintenance',
  Name: 'Name',
  Noresults: 'No results',
  OK: 'OK',
  ProductName: 'Sage Intelligent Time',
  ProductNameShort: 'Intelligent Time',
  Save: 'Save',
  Scheduledsystemmaintenance: 'Scheduled system maintenance',
  Show: 'Show',
  Submit: 'Submit',
  TimeAssistant: 'Time Assistant',
  Unsupportedbrowserversion1:
    "$(ProductName) doesn't support the version of this web browser. Update your browser to the most current version. ",
  Unsupportedbrowserversion2: ' to see a list of supported browsers.',
  common: {
    Required: 'Required',
    PleaseEnablePopups: 'Could not open the window. Please enable popups for this site.',
  },
  activities: {
    Assigned: 'Assigned',
    DropPoolText: 'Drop the activity here to mark it as unassigned',
    Unassigned: 'Unassigned',
  },
  approvals: {
    ApprovalHistory: 'Approval history',
    Approvals: 'Approvals',
    Approvalstage: 'Approval stage',
    Approvaltype: 'Approval type',
    Approve: 'Approve',
    ApproveAll: 'Approve all',
    ApprovedDeclinedby: 'Approved/declined by',
    ApproveCustomer: 'Approve customer',
    ApproveCustomers: 'Approve customers',
    ApproveProject: 'Approve project',
    ApproveProjects: 'Approve projects',
    ApproveTimesheet: 'Approve timesheet',
    ApproveTimesheets: 'Approve timesheets',
    Back: 'Back',
    Billable: 'Billable',
    Cancel: 'Cancel',
    Close: 'Close',
    CollapseAll: 'Collapse all',
    Commentoptional: 'Comment (optional)',
    Comments: 'Comments',
    Customer: 'Customer',
    Decline: 'Decline',
    DeclineAll: 'Decline all',
    DeclineCustomer: 'Decline customer',
    DeclineCustomers: 'Decline customers',
    DeclineProject: 'Decline project',
    DeclineProjects: 'Decline projects',
    DeclineTimesheet: 'Decline timesheet',
    DeclineTimesheets: 'Decline timesheets',
    Description: 'Description',
    Details: 'Entry details',
    Employee: 'Employee',
    Employees: 'Employees',
    Entries: 'Entries',
    Eventdate: 'Event date',
    ExpandAll: 'Expand all',
    GroupBy: 'Group By',
    Item: 'Item',
    Noneselected: 'None selected',
    Notes: 'Notes',
    Notimesheetstoapprove: 'No timesheets to approve',
    Ok: 'Ok',
    Pleaseselectatleastonerowtoapprove: 'Please select at least one row to approve.',
    Pleaseselectatleastonerowtodecline: 'Please select at least one row to decline.',
    Project: 'Project',
    ProjectPeriod: 'Project period',
    Projects: 'Projects',
    SelectAll: 'Select all',
    Submittedto: 'Submitted to',
    Task: 'Task',
    TimeType: 'Time type',
    TimeEntryDetailsfor: 'Time entry details for %{date}',
    Timesheets: 'Timesheets',
    TimesheetPeriod: 'Timesheet period',
    TotalHours: 'Total hours',
    TotalHoursX: 'Total hours - %{hours}',
    TotalResults: 'Total results',
    Xemployeesselected: '%{total} employees selected',
    Xentriesselected: '%{total} entries selected',
    XEntriesSelected: '**%{total}** entries selected',
    XResultsSelected: '**%{total}** results selected',
    Xtimesheetsselected: '%{total} timesheets selected',
    XTimesheetsSelected: '**%{total}** timesheets selected',
    ViewDetails: 'View details',
  },
  auth: {
    Alreadyhaveaccount: 'Already have an account?',
    CheckYourEmail: 'Check your email',
    CompanyID: 'Company ID',
    CompanyName: 'Company name',
    ConfirmPassword: 'Confirm password',
    CreateAccount: 'Create account',
    DisplayName: 'Display name',
    Email: 'Email',
    Username: 'Intacct user ID',
    Entertheemailasociatedwith: `**Please note** that this page is intended for resetting your $(ProductName) password only. If you have forgotten your Intacct password, please reset it through the [Intacct platform](https://www.intacct.com/ia/acct/resetpassword.phtml).

To reset your **$(ProductName)** password, please enter the following information:`,
    FirstName: 'First name',
    Forgotpassword: 'Forgot your password?',
    ForgotYourPassword: 'Forgot your password',
    here: 'here',
    IntacctCompanyID: 'Intacct company ID',
    IntacctUserID: 'Intacct user ID',
    InviteError: 'Token invalid',
    LogIn: 'Log in',
    Next: 'Next',
    Password: 'Password',
    PasswordsDontMatch: "Passwords don't match",
    Pleaseinputpassword: 'Please input the password to continue',
    Resend: 'Resend',
    ResendEmail: 'Resend email',
    ReturntoLogin: 'Return to login',
    Securitycode: 'Security code',
    Or: 'Or',
    ReceiveCodeViaEmail: 'Receive code via email',
    UserID: 'User ID',
    WevepulledyourCompanyIDandUserIDfromIntacct:
      'We ve pulled your company ID and user ID from Intacct. Please create a new password specifically for $(ProductName). You’ll use these three credentials to login. Note, this will not change how you login to Intacct.',
    Wevesentanemailto: "We've sent an email to ",
    MultifactorAuthentication: '2-step authentication',
    MultiFactorAuthenticationMethod: {
      Email: 'We sent a code to your **email**',
      Phone: 'We sent a code to your **phone number**',
    },
    MustBe: 'Must be at least %{number} characters',
  },
  cookieRequirements: {
    Title: 'Unable to load the page.',
    Message: 'Sage Intelligent Time requires browser cookies to load.',
    Directions: "In your browser's settings, add **%{target}** to the list of sites allowed to use third-party cookies.",
  },
  clusters: {
    Activitycardmarkedastrash: 'Activity card marked as trash.',
    Activitycardmarkedasnotattended: 'Activity card marked as not attended.',
    Assign: 'Assign',
    AssignActivityCard: 'Assign activity card',
    Back: 'Back',
    CalendarEvent: 'Calendar event',
    CancelSplit: 'Cancel split',
    clusterIsLocked: 'Activity card is locked.',
    clusterInXTimesheetEntry: 'Activity card associated with %{status} timesheet entry.',
    ComputerActivity: 'Computer activity',
    CostType: 'Cost type',
    Customer: 'Customer',
    Delete: 'Delete',
    Department: 'Department',
    Didnotattend: 'Did not attend',
    EmailActivity: 'Email activity',
    Ifyouwouldliketomovetheactivitytoadifferentproject:
      'If you would like to move the activity to a different project, instead of merging, please click back and edit the assignment details.',
    Item: 'Item',
    Location: 'Location',
    Merge: 'Merge',
    MergeEntries: 'Merge entries',
    NewRow: 'New Row',
    Noactivitiestoassign: 'No activities to assign',
    Noassignedactivities: 'No assigned activities',
    OverlapMessage: 'This activity overlaps with another calendar event. Removing %{clusters} will unlock this activity.',
    Project: 'Project',
    Reassign: 'Reassign',
    Select: 'Select',
    Selecttherowyouwouldliketomergewith: 'Select the row you would like to merge with.',
    Split: 'Split',
    Task: 'Task',
    TimeType: 'Time Type',
    Trash: 'Trash',
    Unassign: 'Unassign',
    UndefinedClusterType: 'Unknown activity type',
    YourcardsforcalendarAssigned: 'Your cards for calendar, computer, and email activity will appear here once they’ve been assigned.',
    YourcardsforcalendarUnassigned: 'Your cards for calendar, computer, and email activity will appear here.',
  },
  date: {
    dateFnsLocale: () => enUS,
    ariaLabels: {
      previousMonthButton: () => 'Previous month',
      nextMonthButton: () => 'Next month',
    },
  },
  dataSources: {
    Account: 'Account',
    AssociatedAccounts: 'Associated accounts',
    albert_good: 'Successfully running the $(TimeAssistant).',
    albert_inactive: 'Your $(TimeAssistant) is either paused or not running right now. Please allow 3 hours after installation to connect.',
    albert_not_yet_synced: 'Sage $(TimeAssistant) not installed.',
    albert_wrong_settings: 'Your $(TimeAssistant) preferences are not configured correctly.',
    ByclickingbelowCalendar:
      'By clicking below to connect your calendar application account(s) means that you agree to our use of your calendar data as stated below and detailed in the ',
    ClickingbelowEmail:
      'Clicking below to connect your email account(s) means that you agree to our use of your email data as stated below and detailed in the ',
    cal_good: 'Successfully connected your calendar.',
    cal_inactive: "You have connected your calendar but we don't have any events from you recently. Please contact support.",
    Calendar: 'Calendar',
    calendarActive: 'This calendar is connected.',
    calendarInactive: 'This calendar is not connected.',
    CalendarSyncedSuccessfully: 'Calendar synced successfully',
    Synconeormoreaccountsbyselectingyourcloudprovider: 'Sync one or more accounts by selecting your cloud provider.',
    chrome_ext_good: 'Successfully installed the Chrome extension.',
    chrome_ext_not_yet_installed: 'Chrome extension not installed',
    Connect: 'Connect',
    ConnectAccount: 'Connect account',
    ConnectAnother: 'Connect another',
    Connectanothercalendar: 'Connect another calendar',
    Connectanothercalendartoautogeneratetimeentries: 'Connect another calendar to auto-generate time entries.',
    Connectanotheremail: 'Connect another email',
    Connectanotheremailaccounttoautogeneratetimeentries: 'Connect another email account to auto-generate time entries.',
    Connectanyofthedatasources: 'Connect any of the time sources above in order to automate and AI-power your timesheets.',
    ConnectCalendar: 'Connect calendar',
    ConnectedDataSources: 'Connected time sources',
    ConnectEmail: 'Connect email',
    Connection: 'Connection',
    Continue: 'Continue',
    DataRetentionPeriod: 'Data retention period',
    DataSource: 'Time source',
    DataSources: 'Time sources',
    DatayouprovideCalendar:
      '**Data you provide:** Calendar information from the time you give consent onward and the week prior to consent date, including content like event description and attachment names, header information like sender, recipients and start and end time, and metadata like created and updated dates.',
    DatayouprovideEmail:
      '**Data you provide:** Email information from the time you give consent onward, including header information like subject, sender, recipients and sent time stamp, and metadata like created and updated dates.',
    days: 'days',
    Delete: 'Delete',
    description:
      "After you've connected time sources, $(ProductName) learns your work activities and automatically pre-populates your timesheet with AI-powered predictions. You maintain control over your data. Only you can see the data gathered.",
    Disclosedto: '**Disclosed to:** The Sage Group plc or a subsidiary (the controller, as to you; the processor, as to your employer).',
    Disconnect: 'Delete',
    documentation: 'documentation.',
    downloaded_not_running:
      "You've downloaded the $(TimeAssistant) but you either haven't logged in to the app or you haven't run the installer yet.",
    Download: 'Download',
    DownloadtheTimeAssistant: 'Download the $(TimeAssistant)',
    email_good: 'Successfully connected your email.',
    email_inactive: 'Connection initiated but no emails found. Please contact support.',
    Email: 'Email',
    EmailSyncedSuccessfully: 'Email synced successfully',
    Error: 'Error',
    FailedtolaunchTimeAssistant: 'Failed to launch $(TimeAssistant). Please open it manually.',
    forhelp: ' for help.',
    GoogleCalendar: 'Google Calendar',
    GoogleEmail: 'Google Email',
    Help: 'Help',
    here: 'here',
    Howtooptout: '**How to opt out:** Click "disconnect" next to the account in the time sources page.',
    InitiatedNoData: 'Connection initiated but no data found.',
    Install: 'Install',
    Installtheapplicationtocapturecomputeractivity: 'Install the application to capture computer activity.',
    Launch: 'Launch',
    LaunchedTimeAssistant: "$(TimeAssistant) launched. If it didn't start please open it manually or check if it is already running.",
    MicrosoftOutlookCalendar: 'Microsoft Outlook Calendar',
    MicrosoftOutlookEmail: 'Microsoft Outlook Email',
    missing_permissions_title: 'Missing permissions',
    missing_permissions_message:
      'The option “**See and download any calendar you can access using your Google Calendar**” needs to be selected in order to connect your calendar.',
    no_active_calendars: 'No calendars selected. Connect a calendar below to retrieve calendar events.',
    no_cal_token_try_again: 'You unsuccessfully attempted to connect your calendar. Please try again.',
    no_cals_syncing: 'Connection initiated but no events found. Please contact support.',
    no_email_token_try_again: 'You unsuccessfully attempted to connect your email.',
    no_emails_syncing: 'Connection initiated. However, no emails have been retrieved yet. Please contact support.',
    NoCalendar: 'Calendar not connected',
    NoData: 'No data.',
    NoDataSourcesConnected: 'No time sources connected',
    NoEmail: 'Email not connected',
    NotApplicable: 'N/A',
    PrivacyPolicy: 'Privacy policy',
    Provider: 'Provider',
    Pullincalendareventstoautogenerateentries: 'Pull in calendar events to auto-generate entries.',
    Pullinemailstoautogeneratetimesheetentries: 'Pull in emails to auto-generate timesheet entries.',
    ReConnect: 'Re-connect',
    ReConnectAccount: 'Re-connect account',
    ReDownload: 'Re-download',
    Retaineduntil:
      '**Retained until:** When connecting your account, you will be prompted to choose how long we retain your data. You can change this setting at any time.',
    RetainMyCalendarDataFor: 'Retain my calendar data for',
    RetainMyEmailDataFor: 'Retain my email data for',
    RetainMyTimeAssistantDataFor: 'Retain my $(TimeAssistant) data for',
    ReturntoDataSources: 'Return to time sources',
    SageIntelligentTimeretainsdatafromtheaccounts:
      '$(ProductName) retains data from the account(s) you connect to help improve its capabilities to predict how activities are assigned. Reducing the retention period of data may impact the quality of these predictions and consequently the accuracy and the time it takes for you to complete your timesheets. You may change this setting at any time.',
    Save: 'Save',
    SetDataRetentionPeriodForThisAccount: 'Set data retention period for this account',
    Status: 'Status',
    StatusMessage: 'Status message',
    SuccessCalendar: 'Successfully connected your calendar.',
    SuccessEmail: 'Successfully connected your email.',
    Syncanotheremailorreturntodatasources: 'Sync another email or return to time sources.',
    Syncanothercalendarorreturntodatasources: 'Sync another calendar or return to time sources.',
    Syncyourdatatogetautogeneratedtimesheets: 'Sync your data to get auto-generated timesheets.',
    TimeAssistant: '$(TimeAssistant)',
    Usedfor:
      '**Used for:** To help you create timesheet entries and to train algorithms that automate creation of timesheet entry descriptions.',
    wait_for_cals: 'You recently connected your calendar. Please wait for up to 24 hours for the initial connection to complete.',
    wait_for_emails: 'You recently connected your email. Please wait for up to 24 hours for the initial connection to complete.',
    YouvedownloadedTimeAssistant: 'Your $(TimeAssistant) is setup, click below to launch it.',
  },
  empty: {
    NoData: 'No Data',
  },
  entries: {
    Billable: 'Billable',
    CostType: 'Cost type',
    Customer: 'Customer',
    Department: 'Department',
    EmployeePosition: 'Employee position',
    Item: 'Item',
    LaborClass: 'Labor class',
    LaborShift: 'Labor shift',
    LaborUnion: 'Labor union',
    Location: 'Location',
    Project: 'Project',
    Select: 'Select',
    Task: 'Task',
    TimeType: 'Time type',
  },
  entry: {
    ActivityCards: 'Activity cards',
    AddNotes: 'Add notes',
    AddNotesAndDimensions: 'Add notes and dimensions',
    Cancel: 'Cancel',
    Client: 'Client',
    Department: 'Department',
    Description: 'Description',
    Dimensions: 'Dimensions',
    EditNotes: 'Edit notes',
    Item: 'Item',
    Loading: 'Loading...',
    Location: 'Location',
    Notes: 'Notes',
    NotesAndDimensions: 'Notes and dimensions',
    NoCustomer: 'Select customer',
    NoProject: 'Select project',
    NoTask: 'Select task',
    NoItem: 'Select item',
    NoTimeType: 'Select time type',
    NoDepartment: 'Select department',
    NoLocation: 'Select location',
    NoCostType: 'Select cost type',
    NoLaborClass: 'Select labor class',
    NoLaborShift: 'Select labor shift',
    NoLaborUnion: 'Select labor union',
    NoEmployeePosition: 'Select employee position',
    Project: 'Project',
    Task: 'Task',
    TimeType: 'Time type',
  },
  errors: {
    messages: {
      blank: 'This field is required',
      unknown_error: 'Unrecognised error, please contact support.',
    },
  },
  network: {
    error: {
      offline: 'No internet connection',
    },
    info: {
      internetRestored: 'Internet connection restored',
    },
  },
  helmet: {
    Approvals: 'Approvals | $(ProductName)',
    DataSources: 'Time Sources | $(ProductName)',
    Home: 'Home | $(ProductName)',
    Intacct: 'Intacct | $(ProductName)',
    Invite: 'Invite | $(ProductName)',
    InternalAdminDashboard: 'Internal Admin Dashboard | $(ProductName)',
    Login: 'Login | $(ProductName)',
    Privacy: 'Privacy | $(ProductName)',
    Provision: 'Provision | $(ProductName)',
    Settings: 'Time Preferences | $(ProductName)',
    Timesheets: 'Timesheets | $(ProductName)',
    ExternalAuth: 'Authentication | $(ProductName)',
  },
  homepage: {
    AIPowered: 'AI-powered',
    Aneweraintimeentry: 'A new era in time entry',
    Billmoretimeandspendlesstimeontimeentry: 'Bill more time and spend less time on time entry',
    Createmanualentries: 'Create manual entries',
    Formodernservicebusinesses: 'For modern service businesses. AI-powered. Available on the web, iOS, and Android.',
    Legal: 'Legal',
    Maintainfullcontroloveryourconnecteddata:
      'Maintain full control over your connected time sources - see our Privacy Policy to learn more',
    Managetimesheetnotifications: 'Manage timesheet notifications',
    PrivacyPolicy: 'Privacy policy',
    Reachouttoourteamtodaytogetademo: 'Reach out to our team today to get a demo',
    SageIntelligentTimeisavailableanytime: '$(ProductName) is available anytime and anywhere with our mobile app.',
    SageIntelligentTimeushers:
      '$(ProductName) ushers in a new era in time entry. Set time tracking on auto-pilot with our AI-powered web and mobile solution.',
    TermsofService: 'Terms of service',
    Timesheets: 'Timesheets',
    Timesheetsforbusinessesthataregoingplaces: 'Timesheets for businesses that are going places',
    Useyourcalendaremailandcomputeractivity: 'Use your calendar email and computer activity to easily create accurate timesheet entries',
    Withourmobileappyoucandothefollowing: 'With our mobile app, you can do the following:',
  },
  navigation: {
    DataSources: 'Time sources',
    Intacct: 'Intacct',
    Privacy: 'Privacy',
    Thirdpartylicences: '3rd party licenses',
    HelpTooltipMessage: 'Help',
    ProfileMenu: {
      LogInMenuItem: 'Log in',
      LogoutMenuItem: 'Logout',
      SettingsMenuItem: 'Time preferences',
      UserInfoMenuItemTitle: 'Logged in as',
      AuthenticatedAltText: 'Profile menu',
      UnauthenticatedAltText: 'Log in menu',
    },
  },
  notFound: {
    GoBack: 'Go back',
    Sorrythispageisntavailable: "Sorry, this page isn't available.",
    Thelinkyoufollowed: 'The link you followed may be broken, or the page may have been removed.',
  },
  notifications: {
    Earlier: 'Earlier',
    New: 'New',
    NoNotifications: 'No notifications',
    Notifications: 'Notifications',
    SeeAllNotifications: 'See all notifications',
  },
  notification: {
    toasts: {
      SAVE_TIMESHEET: {
        SUCCESS: 'Your timesheet has been successfully synced to Intacct',
        ERROR: 'Your timesheet has failed to sync to Intacct',
      },
      SUBMIT_TIMESHEET: {
        SUCCESS: 'Your timesheet has been successfully submitted',
        ERROR: 'Your timesheet failed to submit',
      },
      APPROVALS: {
        DECLINE: {
          SUCCESS: 'Successfully declined',
          ERROR: 'Failed to decline: %{reason}',
        },
        APPROVE: {
          SUCCESS: 'Successfully approved',
          ERROR: 'Failed to approve: %{reason}',
        },
        UNKNOWN: {
          SUCCESS: 'Successfully processed',
          ERROR: 'Failed to process: %{reason}',
        },
      },
    },
  },
  pill: {
    Active: 'Active',
    Approved: 'Approved',
    Declined: 'Declined',
    Draft: 'Draft',
    Error: 'Error',
    Inactive: 'Inactive',
    InvitationSent: 'Invitation sent',
    Invoiced: 'Invoiced',
    NoData: 'No data',
    NoInfo: 'No info',
    NotInvited: 'Not invited',
    Submitted: 'Submitted',
    PartiallyApproved: 'Partially approved',
    PartiallyDeclined: 'Partially declined',
    Processing: 'Processing',
  },
  reset: {
    Login: 'Login',
    Success: 'Success',
    NoMatch: "Passwords don't match",
    ResetPassword: 'Reset your password',
  },
  settings: {
    demoSettings: {
      Activitiesgeneratedsuccessfully: 'Activities generated successfully',
      Customer: '**Customer**',
      GenerateActivityCards: 'Generate activity cards',
      GenerateActivityCardsForThisUser: 'Generate activity cards for this user',
      helmet: 'Demo Preferences',
      Includeoverlappingactivity: 'Include overlapping activity',
      Pleaseselectthedate1:
        'Please select the date, customer, project, and task that you’d like activity cards to demo. Four cards with varying predictions will be generated for the selected date and available on all timesheets that include that date. If you’re having issues, please ensure this user is assigned to projects and tasks with valid dates and active customers in Intacct and then ',
      Pleaseselectthedate2: ' and try again. Please see ',
      Pleaseselectthedate3: ' for details.',
      Project: '**Project**',
      Select: 'Select',
      SpreadDates: 'Spread activities ±1 day from the selected date',
      SyncManually: 'Sync manually',
      subtitle: 'This page is intended for internal/demo use only!',
      Task: '**Task**',
      title: 'Demo preferences',
    },
    billing: {
      button: 'Upgrade Plan',
      helmet: 'Time Preferences | Billing',
      subtitle: 'Manage your subscription.',
      title: 'Billing',
      YouHaveXDaysRemaining: 'You have **{{days}}** days remaining.',
    },
    downloadApp: {
      bullet1: 'Create manual entries',
      bullet2: 'Use your calendar email and computer activity to easily create accurate timesheet entries',
      bullet3: 'Manage timesheet notifications',
      bullet4: 'Bill more time and spend less time on time entry',
      bullet5: 'Maintain full control over your connected time sources - see our [privacy policy](/privacy) to learn more',
      helmet: 'Download App',
      subtitle: '$(ProductName) is available anytime and anywhere with our mobile app.',
      title: 'Download app',
      Withourmobileappyoucando: 'With our mobile app, you can do the following:',
    },
    general: {
      button: 'Update company',
      CompanyAvatar: 'Company avatar',
      CompanyName: 'Company name',
      Currency: 'Currency',
      helmet: 'Time Preferences | General',
      subtitle: 'Update your company name.',
      title: 'General time preferences',
      UploadImage: 'Upload image',
    },
    notifications: {
      Approvals: 'Approvals',
      DayOfWeekToReceiveNotificationEmail: 'Day of week to receive notification email',
      Daily: 'Daily',
      days: {
        Sunday: 'Sunday',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
      },
      DataSources: 'Time sources',
      days_: 'days',
      daysaftertheendofthetimesheetperiod: 'days after the end of the timesheet period',
      daysafterthestartofthetimesheetperiod: 'days after the start of the timesheet period',
      DesktopPush: 'Desktop push',
      Email: 'Email',
      for: 'for',
      helmet: 'Time Preferences | Notifications',
      Notifymevia: 'Notify me via:',
      ontheselecteddays: 'on the selected days',
      RealTime: 'Real-time',
      Receivenotifications: 'Receive notifications',
      SendNotificationsForTrackerApp: 'Send notifications for $(TimeAssistant)',
      SendNotificationsForCalendar: 'Send notifications for calendar',
      SendNotificationsForEmail: 'Send notifications for email',
      subtitle: 'Manage how you receive notifications.',
      TimesheetReminders: 'Timesheet reminders',
      Timesheethasbeeninmyqueuefor: 'Timesheet has been in my queue for',
      title: 'Notifications',
      TurnOnNotifications: 'Turn on notifications',
      WebNotification: 'Web notification',
      Weekly: 'Weekly',
      Whenacalendaraccountisntconnectedproperly: 'When a calendar account isn’t connected properly',
      Whenallorpartofmytimesheethasbeendeclined: 'When all or part of my timesheet has been declined',
      Whenanemailaccountisntconnectedproperly: 'When an email account isn’t connected properly',
      WhenIhavenewtimesheetsinmyqueuetoapprove: 'When I have new timesheets in my queue to approve',
      WhenIhavententeredanytimeby: 'When haven’t entered any time by',
      WhenIhaventcreatedatimesheet: 'When I haven’t created a timesheet',
      WhenIhaventsubmittedatimesheet: 'When I haven’t submitted a timesheet',
      WhentheTimeAssistantisntconnectedproperly: 'When the $(TimeAssistant) isn’t connected properly',
      Whenmytimesheethasbeenapproved: 'When my timesheet has been approved',
      NotifyWhen: 'Notify me when:',
      SubmissionSucceeded: 'Timesheet submission succeeded',
    },
    security: {
      Back: 'Back',
      Cancel: 'Cancel',
      Continue: 'Continue',
      Country: 'Country',
      CurrentPassword: 'Current password',
      Done: 'Done',
      Enteryourmobilephonenumber: 'Enter your mobile phone number. Data charges may apply – check with your mobile carrier.',
      Fromnowon:
        "From now on, when you sign into $(ProductName) on the web, mobile, or $(TimeAssistant), you'll need to enter the security code sent to your phone. Data charges may apply – check with your mobile carrier.",
      GetStarted: 'Get started',
      Ifyoudisabletwostep:
        'If you disable two-step verification, you will only need your username and password to log into $(ProductName) or to link a new device.',
      Invalidphonenumber: 'Invalid phone number',
      Phonenumber: 'Phone number',
      Securitycode: 'Security code',
      stepOneDescription:
        "Two-step verification adds an extra layer of protection to your account. Whenever you sign in to any $(ProductName) application, you'll need to enter both your password and also a verification code sent to your mobile device via text message.",
      stepOneMfaRequired: '**Two-step verification is required by your company.**',
      Wellsendasecuritycode:
        "We'll send a security code to this phone number when you sign into $(ProductName) on the web, mobile, or $(TimeAssistant).",
      Wevesentasecuritycodeto: "We've sent a security code to %{phoneNumber}. Enter it below to verify your phone number.",
    },
  },
  timesheet: {
    Back: 'Back',
    BeginDate: 'Begin date',
    Client: 'Client',
    Dropactivitycardhere: 'Drop activity card here or to an existing timesheet row',
    Droppingtheactivitycardhere: 'Dropping the activity card here will create a new timesheet row',
    EndDate: 'End date',
    LastSynced: 'Last synced %{date}',
    NoSynced: 'Not synced yet',
    Pleaseaddressall: 'Please address all timesheet header and entry errors below and re-submit the timesheet.',
    Project: 'Project',
    Save: 'Save',
    SearchPromptText: 'Type to search',
    Status: 'Status',
    Submit: 'Submit',
    Sync: 'Sync to Intacct',
    Syncing: 'Syncing...',
    Task: 'Task',
    Thistimesheethaserrorsthatmustbefixed: 'This timesheet has errors that must be fixed.',
    Thistimesheethisreadonly: {
      title: 'This timesheet is read-only',
      message: 'The timesheet was not opened from the top level.',
      action: 'Switch to top level',
    },
    Timesheet: 'Timesheet',
    Timesheetheadererrors: 'Timesheet header errors',
    TotalHours: 'Total hours',
    syncStatus: {
      UNSYNCED: 'Not synced',
      SYNCING: 'Syncing...',
      SYNCED: 'Synced',
    },
  },
  timesheetRows: {
    Companysettingsdontallowduplicaterows: "Company preferences don't allow duplicate rows",
    Youcannotassignanactivitytoanentrywithstatus: 'You cannot assign an activity to an entry with status "%{status}"',
  },
  timesheets: {
    ActiveTimesheets: 'Active timesheets',
    Addatimesheetanditwillshowuphere: 'Add a timesheet and it will show up here.',
    AddFilter: 'Add filter',
    After: 'After',
    AllTimesheets: 'All timesheets',
    Apply: 'Apply',
    AreYouSure: {
      one: 'The following timesheet will be permanently deleted.',
      other: 'The following timesheets will be permanently deleted.',
      zero: 'You selected zero timesheets.',
    },
    AreYouSureSubmit: {
      one: 'Are you sure you would like to submit the selected timesheet?',
      other: 'Are you sure you would like to submit the selected timesheets?',
      zero: 'You selected zero timesheets.',
    },
    Before: 'Before',
    BeginDate: 'Begin date',
    BeginDateHelp:
      'Select the date that this timesheet begins. Your company settings determine which day of the week timesheets can start. Admins can change the setting by going to **Company** > **Setup** > **Company** > **Accounting** and adjusting the **Week begins on** field.',
    Cancel: 'Cancel',
    Clear: 'Clear',
    Client: 'Client',
    ColumnName: 'Column name',
    ConfigureColumns: 'Configure columns',
    CreateTimesheet: 'Create timesheet',
    Dates: 'Dates',
    Delete: 'Delete',
    DeleteTimesheets: {
      one: 'Delete timesheet',
      other: 'Delete %{count} timesheets',
      zero: 'Delete 0 timesheets',
    },
    Description: 'Description',
    Duplicate: 'Duplicate',
    DuplicateTimesheet: 'Duplicate timesheet',
    Employee: 'Employee',
    EmployeeId: 'Employee ID',
    EmployeeName: 'Employee name',
    EndDate: 'End date',
    EndDateHelp:
      'The end date is automatically calculated based on your selected begin date and your company settings. Admins can change the setting by going to **Projects** > **Setup** > **Projects configuration** and adjusting the **Timesheet duration** field. The duration can be daily, weekly, every two weeks, or twice per month.',
    EntityName: 'Entity',
    Equalto: 'Equal to',
    Filter: 'Filter',
    Greaterthan: 'Greater than',
    IncludeEntries: 'Include entries',
    InvalidTimesheetStartDate: 'Invalid start date. Select a date that is %{day}',
    InvalidTimesheetStartDateStartOrMidOfMonth: 'Invalid start date. Select the 1st or the 16th of the month',
    Lessthan: 'Less than',
    Notequalto: 'Not equal to',
    Project: 'Project',
    SelectedTimesheets: 'Selected timesheets',
    Startbuildingyourtimesheet: 'Start building your timesheet!',
    State: 'State',
    Status: 'Status',
    Submit: 'Submit',
    SubmitTimesheets: {
      one: 'Submit timesheet',
      other: 'Submit %{count} timesheets',
      zero: 'Submit 0 timesheets',
    },
    Task: 'Task',
    Timesheet: 'Timesheet',
    BillableHours: 'Billable hours',
    TotalHours: 'Total hours',
    NonBillableHours: 'Non-billable hours',
    Value: 'Value',
  },
  externalAuth: {
    Authenticating: {
      alt: 'Authenticating',
    },
    Error: {
      title: 'Something went wrong.',
      message: 'Please try again or contact support.',
      retry: 'Retry',
    },
  },
};

export default en;
